import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import ShowListDichVuCong from "@/pages/ShowListDichVuCong.vue";
import addAccountantPage from "@/pages/AddAccountantPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: RegisterPage,
  //   props: true
  // },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/addAccountantPage',
    name: 'addAccountantPage',
    component: addAccountantPage,
    props: true
  },
  // {
  //   path: '/sendmessage',
  //   name: 'sendmessage',
  //   component: SendMessagePage,
  //   props: true
  // },
  // {
  //   path: '/uploadImage',
  //   name: 'uploadImage',
  //   component: UploadImage,
  //   props: true
  // },
  // {
  //   path: '/managerGroup',
  //   name: 'managerGroup',
  //   component: addGroupAndMemberPage,
  //   props: true
  // },
  // {
  //   path: '/userList',
  //   name: 'userList',
  //   component: UserList,
  //   props: true
  // },
  {
    path: '/showListDVC',
    name: 'showListDVC',
    component: ShowListDichVuCong,
    props: true
  },
  // {
  //   path: '/qrCode',
  //   name: 'showQrCodePage',
  //   component: showQrCodePage,
  //   props: true
  // },
  // {
  //   path: '/addTax',
  //   name: 'addTax',
  //   component: AddTax,
  //   props: true
  // },
  // {
  //   path: '/userUpdate/:id',
  //   name: 'userUpdate',
  //   component: UserUpdatePage,
  //   props: true
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
